import * as firebase from 'firebase';
import { firebase as firebaseInChat } from 'nm-react-chat';
import { firebase as firebaseInQuiz } from 'nm-react-quiz';

import { firebaseConfig } from './../../conf/config';

const firebaseApp = firebase.initializeApp(firebaseConfig);
firebaseInChat.initFirebase(firebaseApp);
firebaseInQuiz.initFirebase(firebaseApp);

export default firebaseApp;


export function displayFirebaseError (e) {
    const code = e.code || "";
    switch ( code ) {
        case "auth/requires-recent-login":
            return "Tu dois avoir une connexion récente pour faire cette opération, déconnecte-toi et réessaie";
        case "auth/weak-password":
            return "Ce champs doit contenir 6 caractères min. dont au moins une majuscule et un chiffre.";
        default:
            return "Une erreur innatendu est apparue lors d'un appel à firebase.";
    }
}


// WEBPACK FOOTER //
// ./src/utils/firebase/firebase.js